const WAIT_FOR_PRODUCTS = {};

export default {
  namespaced: true,
  state: {
    products: [],
    groups: {},
    monitoringSettings: {},
  },
  getters: {
    groupCodes(state) {
      return state.products.reduce((groups, product) => {
        if (!groups.includes(product.group)) {
          groups.push(product.group);
        }

        return groups;
      }, []);
    },
    findProductById(state, getters) {
      return (id) => getters.findProductBy('id', id);
    },
    findProductBy(state) {
      return (field, value) => state.products.find((product) => product[field] === value);
    },
    groupedProducts(state) {
      return state.products.reduce((all, product) => {
        all[product.group] = all[product.group] || [];
        all[product.group].push(product);
        return all;
      }, {});
    },
    vatPercent(state) {
      return state.vatPercent;
    },
  },
  mutations: {
    setProducts(state, {
      translations, services, prices, vatPercent,
    }) {
      const groupedPrices = prices.reduce((acc, item) => {
        acc[item.productCode] = item;
        return acc;
      }, {});

      state.groups = translations.groups;
      state.products = services.map(function (service) {
        return {
          ...translations.items[service.id],
          ...service,
          ...groupedPrices[service.productCode],
          aliasedProduct: service.alias ? translations.items[service.alias.id] : null,
        };
      });
      state.vatPercent = vatPercent;
    },

    selectProduct(state, id) {
      state.selectedProduct = id;
    },
    setMonitoringSettings(state, settings) {
      state.monitoringSettings = settings;
    },
    updateMonitoringSettings(state, settings) {
      Object.assign(state.monitoringSettings, settings);
    },
  },
  actions: {
    loadProducts({ commit, rootGetters }) {
      const { locale, api } = rootGetters;
      let loadProducts = WAIT_FOR_PRODUCTS[locale];
      if (!loadProducts) {
        const requests = [
          import(`../../lang/products/${locale}.yml`),
          api.get('/products'),
        ];
        loadProducts = Promise.all(requests);
        WAIT_FOR_PRODUCTS[locale] = loadProducts;
      }
      loadProducts
        .then(([translations, products]) => commit('setProducts', {
          translations: translations.default || translations,
          services: rootGetters.services,
          prices: products.data.products,
          vatPercent: products.data.vatPercent,
        }));

      return loadProducts;
    },
    reloadProducts({ dispatch }) {
      Object.keys(WAIT_FOR_PRODUCTS)
        .forEach((locale) => WAIT_FOR_PRODUCTS[locale] = null);

      return dispatch('loadProducts', { root: true });
    },
    getProductById({ getters, rootGetters }, id) {
      return WAIT_FOR_PRODUCTS[rootGetters.locale]
        .then(() => getters.findProductById(id));
    },
    getProductBySlug({ getters, rootGetters }, slug) {
      return WAIT_FOR_PRODUCTS[rootGetters.locale]
        .then(() => getters.findProductBy('slug', slug));
    },
    findRelatedProductsFor({ getters }, product) {
      const products = (product.relatedIds || []).map(getters.findProductById);
      return Promise.resolve(products);
    },
    getMyPaymentDefaults({ rootGetters }) {
      return rootGetters.api.get('/reports/my-payment-defaults')
        .then((response) => response.data);
    },
    getRelatedCompanyPaymentDefaults({ rootGetters }) {
      return rootGetters.api.get('/reports/related-company-payment-defaults')
        .then((response) => response.data);
    },
    getMyCreditInquiry({ rootGetters }) {
      return rootGetters.api.get('/reports/my-credit-enquiry')
        .then((response) => response.data);
    },
    getReportSample({ rootGetters }, name) {
      return rootGetters.api.get(`/reports/samples/${name}`)
        .then((response) => response.data);
    },
    getMyMonitoringEvents({ rootGetters }, params) {
      return rootGetters.api.get('/reports/my-monitoring-events', { params })
        .then((response) => response.data);
    },
    loadMyMonitoringSettings({ commit, rootGetters }) {
      return rootGetters.api.get('/reports/my-monitoring-settings')
        .then((response) => commit('setMonitoringSettings', response.data));
    },
    updateMonitoringSettings({ commit, rootGetters }, params) {
      return rootGetters.api.patch('/reports/my-monitoring-settings', params)
        .then(() => commit('updateMonitoringSettings', params));
    },
  },
};
